/** Сколько кусков одного файла запрашивается одновременно при скачивании */
export const CHUNKS_AT_ONCE = 4

/**
 * Чтение файла кусками с опережением: запрос куска i сразу ставит в работу куски до i + CHUNKS_AT_ONCE - 1,
 * поэтому последовательная запись на диск идёт параллельными запросами к узлу.
 */
export class ChunkReader {
  private inFlight = new Map<number, Promise<Uint8Array>>()

  constructor(private count: number, private fetch: (index: number) => Promise<Uint8Array>) {}

  async read(index: number): Promise<Uint8Array> {
    for (let next = index; next < Math.min(index + CHUNKS_AT_ONCE, this.count); next++) {
      if (!this.inFlight.has(next)) {
        const promise = this.fetch(next)
        // отказ куска всплывёт при его чтении; без этого обработчика Node считает отказ необработанным
        promise.catch(() => undefined)
        this.inFlight.set(next, promise)
      }
    }
    const promise = this.inFlight.get(index)
    if (promise === undefined) {
      throw new Error('chunk out of range: ' + index)
    }
    this.inFlight.delete(index)

    return promise
  }
}
